import React from 'react';
import { TableRowProps } from '../tableRow/tableRow';

interface TableBodyProps
    extends React.TableHTMLAttributes<HTMLTableSectionElement> {
    children?:
        | React.ReactElement<TableRowProps>[]
        | React.ReactElement<TableRowProps>;
}

/**
 * @name    m-table-body
 * @componentType    atom
 *
 * @param   {ReactNode} children        Content of the table body section
 *
 * @description
 * This is a body section of a table
 */

const TableBody = React.forwardRef<HTMLTableSectionElement, TableBodyProps>(
    ({ children, ...rest }, ref) => {
        return (
            <tbody ref={ref} {...rest}>
                {children}
            </tbody>
        );
    },
);

TableBody.displayName = 'TableBody';

export { TableBody, TableBodyProps };
